import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { dsViewStyles } from 'ds-shared-lib/src/base/css/ki-ds-view-styles.css';

import nls from '../../locales/indexes.nls';
import {
    fetchChannelMetaData,
    fetchLastValues,
    fetchTimeseriesMeta,
    getChannelIdFromUrl,
    getTimeseriesIdsFromUrl,
    groupByLocation,
} from '../../services/channel';
import { showToast } from '../../services/toast-service';
import KiDsPwaView from '../pwa-view/ki-ds-pwa-view';
import styles from './multigraph-view.css';
import '../../components/ki-ds-pwa-graph-container/ki-ds-pwa-graph-container';

const CLASS_NAME = 'multigraph-view';

@i18n(nls)
@customElement(CLASS_NAME)
class KiDsMultiGraphView extends KiDsPwaView {
    static styles = [...dsViewStyles, styles];

    static get properties() {
        return {
            tsIdList: { type: Array },
            timeseriesMetaList: { type: Array },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.tsIdList = [];
        this.timeseriesMetaList = [];
        this.isLoading = true;
    }

    async firstUpdated() {
        super.firstUpdated();
        await this._loadView();
    }

    async _loadView() {
        this.isLoading = true;
        try {
            this.channelId = getChannelIdFromUrl();

            const [channel, timeseriesMeta, lastValues] = await Promise.all([
                fetchChannelMetaData(this.channelId),
                fetchTimeseriesMeta(this.channelId),
                fetchLastValues(this.channelId),
            ]);

            this._setDocumentTitle(channel);
            this._dispatchChannelLoaded(channel);
            this._selectTimeseriesFromUrl(timeseriesMeta, lastValues);
        } catch (_err) {
            showToast({ content: 'Failed to load channel data', type: 'error' });
        } finally {
            this.isLoading = false;
        }
    }

    _selectTimeseriesFromUrl(timeseriesMeta, lastValues) {
        const grouped = groupByLocation(timeseriesMeta, lastValues);
        const allTimeseries = Object.values(grouped).flat();
        const presetTsIds = getTimeseriesIdsFromUrl();
        this.timeseriesMetaList =
            presetTsIds.length > 0
                ? allTimeseries.filter((timeseries) => presetTsIds.includes(timeseries.id))
                : allTimeseries;
        this.tsIdList = this.timeseriesMetaList.map((timeseries) => timeseries.id);
    }

    render() {
        return html`
            <div class="view">
                <ki-ds-pwa-graph-container
                    .tsIdList=${this.tsIdList}
                    .currentMetaList=${this.timeseriesMetaList}
                    .channelId=${this.channelId}
                    .isLoading=${this.isLoading}
                ></ki-ds-pwa-graph-container>
            </div>
        `;
    }
}
